import React, { useState } from "react";
import { Button, Input, message, Modal, notification } from "antd";
import {
  Underwriter,
  UnderwriterList,
} from "./UnderwriterList/UnderwriterList";
import {
  SELECT_UNDERWRITERS,
  SELECT_USER_DATA,
} from "../../../store/selectors/authSliceLoginSelector";
import { useSelector } from "react-redux";
import {
  useGetApplicationDataToBankQuery,
  useSetApplicationUnderwriterMutation,
  useSetNewApplicationUnderwriterMutation,
} from "../../../store/api/applicationBankApi/applicationBank.api";
import { useNavigate, useParams } from "react-router-dom";
import style from "./UnderwriterChange.module.css";
import { getFullName } from "../../../utils/utilities/getFullName";
import { APPLICATION_BANK_STATUS } from "../../../utils/guards/ApplicationBankStatusGuard/types";
import { useAppSelector } from "../../../store/reduxHooks";
import { USER } from "../../../types";
interface UnderwriterChangeModalProps {
  isOpen: boolean;
  hideModal: () => void;
}

export function UnderwriterChangeModal(props: UnderwriterChangeModalProps) {
  const { isOpen, hideModal } = props;
  const { applicationBankId } = useParams();
  const navigate = useNavigate();

  const underwriters: readonly Underwriter[] = useSelector(SELECT_UNDERWRITERS);
  const userInfo = useAppSelector(SELECT_USER_DATA);

  const [setApplicationUnderwriter, { isLoading: isChangeUnderwriterLoading }] =
    useSetApplicationUnderwriterMutation();
  const [setNewApplicationUnderwriter, { isLoading: isSetUnderwriterLoading }] =
    useSetNewApplicationUnderwriterMutation();

  const { data: applicationBankData } = useGetApplicationDataToBankQuery(
    Number(applicationBankId)
  );

  const [filteredUnderwriters, setFilteredUnderwriters] =
    useState(underwriters);
  const [selectedUnderwriter, setSelectedUnderwriter] =
    useState<Underwriter | null>(null);

  /**
   * @description
   * Фильтрование андеррайтеров в поиске по запросу
   */
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value;
    const filteredItems = underwriters.filter((user) =>
      `${user.surname} ${user.name} ${user.patronymic}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
    setFilteredUnderwriters(filteredItems);
  };

  /**
   * @description
   * Смена андеррайтера на выбранного или назначение выбранного андеррайтера на заявку
   */
  const handleOk = async () => {
    if (!selectedUnderwriter || !applicationBankId) {
      return;
    }

    const applicationData = {
      applicationBankId: +applicationBankId,
      underwriterId: selectedUnderwriter.id,
    };

    const isNewApplication =
      applicationBankData?.modified_bank_status.type ===
      APPLICATION_BANK_STATUS.NEW_APPLICATION;

    try {
      if (isNewApplication) {
        await setNewApplicationUnderwriter(applicationData).unwrap();
        if (userInfo.type === USER.UNDERWRITER) {
          navigate("/", { replace: true });
        }
        notification.success({
          message: "Андеррайтер назначен",
          description: `Заявка № ${applicationBankId} была успешно передана андеррайтеру: ${getFullName(
            selectedUnderwriter
          )}`,
          duration: 0,
        });
      } else {
        await setApplicationUnderwriter(applicationData).unwrap();
        if (userInfo.type === USER.UNDERWRITER) {
          navigate("/", { replace: true });
        }
        notification.success({
          message: "Андеррайтер изменен",
          description: `Заявка № ${applicationBankId} была успешно передана новому андеррайтеру: ${getFullName(
            selectedUnderwriter
          )}`,
          duration: 0,
        });
      }
    } catch (error) {
      message.error("Не получилось назначить андеррайтера");
    } finally {
      hideModal();
    }
  };

  const handleCancel = () => {
    hideModal();
  };

  return (
    <>
      <Modal
        className={`${style.modal}`}
        open={isOpen}
        title="Список андеррайтеров"
        footer={false}
        closeIcon={false}
      >
        <Input.Search
          placeholder="Поиск по имени"
          style={{ marginBottom: "10px" }}
          onChange={handleInputChange}
        />
        <UnderwriterList
          underwriters={filteredUnderwriters}
          selectedUnderwriter={selectedUnderwriter}
          setSelectedUnderwriter={setSelectedUnderwriter}
        />
        <div className={`${style.div}`}>
          <Button onClick={handleCancel}>Отменить</Button>

          <Button
            type="primary"
            onClick={handleOk}
            loading={isSetUnderwriterLoading || isChangeUnderwriterLoading}
          >
            Подтвердить выбор
          </Button>
        </div>
      </Modal>
    </>
  );
}
